export default "__VITE_ASSET__BRRnOoxK__"